<template>
  <div class='skeleton' :style="{height:height}">

  </div>
</template>
<script>
export default {
  props:{
    height: {
      type: String,
      default: '100vh'
    }
  }
}
</script>

<style lang="scss" scoped>
.skeleton{
  background-color: #e5e5e5;
  width: 100%;
}
</style>
